import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

export enum OfferType {
    preEvent = 1,
    live = 2,
}

export enum OfferStatus {
    active = 'active',
    stop = 'stop',
    block = 'block',
    finished = 'finished',
    canceled = 'canceled',
}

export const SuperOfferKeys = {
    superCota: 'superKvota',
    superExtra: 'superExtra',
} as const;
export type SuperOfferKeys = typeof SuperOfferKeys[keyof typeof SuperOfferKeys];

export const SuperOfferOrder: Record<SuperOfferKeys, string> = {
    [SuperOfferKeys.superCota]: '3',
    [SuperOfferKeys.superExtra]: '4',
};

export enum VideoProviderType {
    IMG = 1,
    BETRADAR = 2,
    YOUTUBE = 4,
    TWITCH = 5,
    PERFORM = 6,
    BET_GENIUS = 7,
    IMG_VISUALIZATION_WIDGET = 8,
    INFRONTSPORTS = 9,
    BETER = 11,
}

export const EventCategory = {
    Outright: 'OUTRIGHT',
} as const;

export type EventCategory = typeof EventCategory[keyof typeof EventCategory];

export const superOfferLocalizedNamesLookup: Record<Country, Record<SuperOfferKeys, string>> = {
    [Country.Ro]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.RoNapoleon]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Pl]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Com]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Br]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.BrSocial]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Rs]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Be]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
    [Country.Bg]: {
        [SuperOfferKeys.superCota]: 'superKvota',
        [SuperOfferKeys.superExtra]: 'superExtra',
    },
};

export function getSuperOfferLocalizedNames() {
    return superOfferLocalizedNamesLookup[
        getConfig().countrySpecific.country
    ];
}
